export default __webpack_public_path__ + "static/media/Maths.11fad7ef.gif";